/** Card/pin display sizes — hints for browser decode priority, not server resize. */
export const IMAGE_SIZES = {
  mapPin: 48,
  carouselCard: 120,
  galleryHero: 480,
};

export function getProfileImageUrl(profile) {
  return profile?.image ?? profile?.photos?.[0] ?? profile?.media ?? "";
}
